<!--
2023-07-26 YTW
-->
<template>
  <div class="gift-pop">
    <div class="main-content">
      <div class="content-container">
        <div class="content-top" :style="{backgroundImage:'url('+require('../../assets/images/timeLimitDeposit/background_top.png')+')'}">
          <p>{{$t('lang.WelfareDeposit.title1')}}</p>
        </div>
        <div class="content-middle">
          <p>{{$t('lang.WelfareDeposit.title2')}} {{timeLimitRate}}% {{$t('lang.WelfareDeposit.title3')}}</p>
          <div class="count-down">
            <div class="count-down-num">{{timeLeftString.substr(0,2)}}</div>
            <div>:</div>
            <div class="count-down-num">{{timeLeftString.substr(3,2)}}</div>
            <div>:</div>
            <div class="count-down-num">{{timeLeftString.substr(6,2)}}</div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="buttons">
            <button class="first-btn" @click="toDeposit">
              {{$t('lang.WelfareDeposit.deposit')}}
            </button>
            <div class="last-btn" @click="closeTimeLimitDeposit">
              {{$t('lang.WelfareDeposit.cancel')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimeLimitDeposit',
  props: ['closeTimeLimitDeposit', 'timeLeftString', 'timeLimitRate', 'timeLimitMaxAmount'],
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  updated () {
  },
  watch: {
    timeLeftString: function (n, o) {
      if (n === '00:00:00') {
        this.closeTimeLimitDeposit()
      }
    }
  },
  methods: {
    loadData () {
    },
    toDeposit () {
      this.closeTimeLimitDeposit()
      localStorage.setItem('limitTimeMaxAmount', this.timeLimitMaxAmount)
      localStorage.setItem('limitTimeRate', this.timeLimitRate)
      this.$router.push({name: 'Deposit', query: {param: 'limitTime'}})
    }
  }
}
</script>

<style lang="less" scoped>
.gift-pop{
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.75);
  z-index: 990;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  background-position: bottom;
  background-origin: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;

  .main-content{
    align-self: center;
    .content-container{
      display: block;
      position: fixed;
      left: 0;
      top: 25vh;
      min-width: max-content;
      height: 54.32vh;
      .content-top {
        position: relative;
        text-align: left;
        margin-left: 4vw;
        padding: 8vh 10vw 0 10vw;
        font-size: 3.8vh;
        font-weight: 700;
        line-height: 3.9vh;
        letter-spacing: 0em;
        color: #FFFFFF;
        text-shadow: 1px 1px 0 #1A1A1A,
        -1px 1px 0 #1A1A1A,
          1px -1px 0 #1A1A1A,
          -1px -1px 0 #1A1A1A,
        0px 1px 0 #1A1A1A,
          0px -1px 0 #1A1A1A,
        -1px 0px 0 #1A1A1A,
        1px 0px 0 #1A1A1A,
        2px 2px 0 #1A1A1A,
        -2px 2px 0 #1A1A1A,
          2px -2px 0 #1A1A1A,
          -2px -2px 0 #1A1A1A,
        0px 2px 0 #1A1A1A,
          0px -2px 0 #1A1A1A,
        -2px 0px 0 #1A1A1A,
        2px 0px 0 #1A1A1A,
        1px 2px 0 #1A1A1A,
        -1px 2px 0 #1A1A1A,
          1px -2px 0 #1A1A1A,
          -1px -2px 0 #1A1A1A,
        2px 1px 0 #1A1A1A,
        -2px 1px 0 #1A1A1A,
          2px -1px 0 #1A1A1A,
          -2px -1px 0 #1A1A1A;
        width: 100vw;
        height: 18.14vh;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-top-left-radius: 1.2vh;
        border-top-right-radius: 1.2vh;
      }
      .content-middle {
        position: relative;
        background-color: #FFFFFF;
        margin-left: calc(4vw + 1px);
        padding-top: 2vh;
        text-align: center;
        font-size: 2.85vh;
        font-weight: 700;
        line-height: 3.23vh;
        letter-spacing: -0.05vh;
        color: #000000;
        width: 91.5vw;
        height: 25vh;
        border-bottom-left-radius: 1.2vh;
        border-bottom-right-radius: 1.2vh;
        .count-down{
          display: flex;
          justify-content: center;
          margin-top: 4vh;
          font-size: 5.8vh;
          font-weight: 700;
          line-height: 7.5vh;
          letter-spacing: 0.03vh;
          text-align: center;
          .count-down-num{
            background: #2A2A27;
            color: #FFFFFF;
            border-radius: 1vh;
            height: 7.5vh;
            width:7.5vh;
          }
        }
      }
      .content-bottom{
        position: relative;
        .buttons {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 95vw;
          margin: 30px auto;
          .first-btn {
              margin-bottom: 1.5vh;
              height: 48px;
              width: 80%;
              background-color: #f1dab0;
              border: none;
              border-radius: 8px;
              font-size: 22px;
              font-weight: 700;
              color: #000000;
          }
          .last-btn {
            background: rgba(0,0,0,0);
            font-size: 1.71vh;
            font-weight: 500;
            line-height: 2vh;
            text-align: center;
            color: #696969;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TimeLimitDeposit/index.vue